// extracted by css-extract-rspack-plugin
export default {"BannerContainer":"tNTTX","BannerBody":"neq8h"};